/*
 * @Author: Vanny
 * @Date: 2019-08-19 15:53:03
 * @LastEditors: Vanny
 * @LastEditTime: 2020-07-06 16:26:05
 * @Description: 关系管理-仓库
 */
import { call, select, put } from 'redux-saga/effects';
import moment from 'moment';
import * as relativeApi from '../../services/customerApi';
import * as constants from '../../config/constants';
import { customerFilter } from '../../config/constants';
import { fewDayAgo } from '../../utils/date';
import { exportToExcelFromNet } from '../../utils';
import { $t } from '../../tools';

export const initConfig = {
  exist: false,
  query: {
    days: -1,
    isasc: 0,
    order: 'utime',
    page: 1,
    page_num: 50,
    sday: moment(fewDayAgo(7)),
    eday: moment(),
  },
  duokeFilter: {
    filters: [],
    radios: [],
  },
  pagination: {
    current: 1,
    total: 0,
    pageSize: 50,
  },
  list: [],
};

const initialState = {
  customer: { ...initConfig },
  supplier: { ...initConfig },
  vipNum: {},
};

export const state = initialState;

export const effects = {
  *getList({ payload }) {
    const {
      type,
    } = payload;
    const { appState, relativeState } = yield select();
    const { vipNum } = relativeState;
    const { query, pagination } = relativeState[type] || {};
    const q = {
      ...query,
      page: pagination.current,
      page_num: pagination.pageSize,
    };
    const response = query.keyword
      ? yield call(relativeApi.requestCustomerSearch, {
          client_type: type === 'customer' ? '1' : '2',
          ...q,
        })
      : yield call(relativeApi.requestCustomerList, {
          ...q,
          type: type === 'customer' ? '1' : '2',
        });
    if (response) {
      const filterList=response?.list?.filter((v) => v.id > 0);
      yield put({
        type: 'relative/setState',
        payload: {
          [type]: {
            ...(relativeState[type] || {}),
            exist: true,
            list: filterList,
            pagination: { ...pagination, total: Number(response?.list_num || 0) },
          },
          vipNum:
            response.vip_num?.reduce((acc, cv) => {
              if (acc[cv.vip]) return acc;
              acc[cv.vip] = cv.num;
              return acc;
            }, {}) || vipNum,
        },
      });
      yield put({
        type: 'relative/transformFilter',
        payload: { appState, type },
      });
    }
  },
  *batchSetAttribute({ payload }) {
    yield call(relativeApi.requestCustomerAttrBatch, payload);
  },
  *fetchBatchAdd({ payload }) {
    return yield call(relativeApi.requestBatchAdd, payload);
  },
  // 关系导出
  *exportList(payload) {
    const relativeState = yield select((state) => state.relativeState);
    const {
      payload: { type, ...props },
    } = payload;
    const {
      query: { page, sday, eday, page_num, order, ...q },
    } = relativeState[type] || {};
    let params = {
      ...q,
      ...props,
      order,
      type: type === 'customer' ? '1' : '2',
      out: 'excel',
      async: '0',
    }
    if (['transaction_money', 'transaction_sum'].includes(order)) {
      params = {...params,...{sday, eday}}
    }

    let res = yield call(relativeApi.requestExportCustomer, params);
    let title = '';
    if (type === 'customer') {
      title = $t('Client', 'Sider');
    } else if (type === 'customer') {
      title = $t('supplier_', 'Sider');
    }
    if (res) {
      exportToExcelFromNet(res, title);
    }
  },
  // 模糊搜索，未使用
  *searchKeywords({ payload }) {
    const response = yield call(relativeApi.requestCustomerSearch, payload);
    const relativeState = yield select((state) => state.relativeState);
    const { type } = relativeState;
    const { pagination } = relativeState[type] || {};

    if (response) {
      yield put({
        type: 'relative/setState',
        payload: {
          [type]: {
            ...(relativeState[type] || {}),
            list: response.list,
            pagination: { ...pagination, total: response.list_num },
          },
        },
      });
    }
  },
};

export const reducers = {
  transformFilter(state, { payload }) {
    const { vipNum } = state;
    const {
      type,
      appState: {
        attrList,
        attrMap,
        attrAliasList,
        userInfo: { plugins_info: pluginsInfo = [], staff_list: staffList = [], shop_list: shopList = [], role },
      },
    } = payload;
    const sysFilters = Object.keys(attrList)
      .filter((k) => ['client_cat1', 'client_cat2', 'client_cat3', 'client_cat4'].includes(k))
      .map((k) => {
        const key = Object.keys(attrMap).find((subK) => subK === k);
        const map = attrMap[key];
        const aliasMap = attrAliasList.find((alias) => alias.attr === map.type_alias_name);
        return {
          name: aliasMap.alias,
          code: map.type_id_name,
          options: attrList[k]
            .map((attr) => ({ name: attr.name, value: attr.id }))
            .concat({ name: $t('unselected', 'TableWrapper'), value: '0' }),
        };
      });
    const plugin135 = pluginsInfo.find((sub) => sub.plugins_id === '135');
    const cusFilters =
      !!plugin135 && type === 'customer'
        ? customerFilter.map((cf) =>
            cf.code === 'vip'
              ? {
                  ...cf,
                  name: cf.name,
                  text: `(${Object.values(vipNum).reduce(
                    (prev, cur) => Number(prev) + Number(cur),
                    0
                  )})`,
                  options: cf.options.map((o) => ({
                    ...o,
                    name: o.name,
                    text: `(${vipNum[o.value]})`,
                  })),
                }
              : cf
          )
        : [];

    const plugin105 = pluginsInfo.find((sub) => sub.plugins_id === '105');
    const saleOptions = staffList.map((g) => ({ name: g.name, value: g.id }));
    const saleFilters = !!plugin105
      ? [
          {
            name: 'staff',
            code: 'staff_id',
            options: saleOptions,
          },
        ]
      : [];

    const filters = cusFilters.concat(
      role === 'manager'
        ? []
        : [
            {
              ...constants.shopFilter,
              options: shopList.map((v) => ({ name: v.name, value: v.id })),
            },
          ],
      sysFilters,
      saleFilters
    );
    const radios = filters.map((f) => f.code);
    state[type].duokeFilter = { filters, radios };
    return { ...state };
  },
};
